import { FEATURE_FLAG_INSTORE_PROMOTION } from '@config/feature-flag';
import { isWithinDateRangePST } from '@utils/dateAndTime/isBetween';
import { useLocale } from '@hooks/useLocale';
import { RichText, RichTextBlock } from 'prismic-reactjs';
import linkResolver from '@adapters/prismic/utils/linkResolver';
import spuPromoData from '../../../prismic-spu-promo.json';
import DealsBanner from '_components/UI/DealsBanner';
import styles from './InStorePromoMessage.module.scss';

interface SpuPromo {
  offerName: RichTextBlock[];
  startDate: string;
  endDate: string;
  offerText: RichTextBlock[];
}

interface SpuPromoData {
  en: SpuPromo[];
  fr: SpuPromo[];
}

const InStorePromotion = () => {
  const locale = useLocale();

  if (!FEATURE_FLAG_INSTORE_PROMOTION) {
    return null;
  }

  const promos = (spuPromoData as SpuPromoData)[locale as 'en' | 'fr'] || [];

  const activePromo = promos.find((promo) =>
    isWithinDateRangePST(promo.startDate, promo.endDate)
  );

  if (!activePromo) {
    return null;
  }

  return (
    <div className={styles.dealsBannerContainer}>
      <DealsBanner
        variant="promos"
        title={activePromo?.offerName[0].text}
        firstLine={
          <div className={styles.inStorePromoMessage}>
            <RichText
              render={activePromo.offerText}
              linkResolver={linkResolver}
            />
          </div>
        }
      />
    </div>
  );
};

export default InStorePromotion;
